import React, { useRef, useState } from "react";
import "./ASGConnect2025Registration.css";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

const ProgrammeOutline = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  const [agree, setAgree] = useState(false); // Track checkbox
  const file = '/Conference-Papers/6page program outline.pdf'
  const pdfUrl = decodeURIComponent(file); 
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  if (!isOpen) return null;

  // Close when clicking outside modal content
  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!agree) {
      alert("Please agree to the registration terms before proceeding.");
      return;
    }

    alert("Thank you for registering! 🎉");
    onClose();
  };

  return (
    <div className="asg-modal-overlay" onClick={handleOverlayClick}

    >
      <div className="asg-modal" ref={modalRef}>
        <button className="asg-close-btn" onClick={onClose}>
          &times;
        </button>

        <h2 className="asg-modal-title">Programme Outline</h2>

        {/* Programme Outline */}
        {/* PDF Viewer */}
        <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@3.9.179/build/pdf.worker.min.js`}
        >
          <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      </div>
    </div>
  );
};

export default ProgrammeOutline;
